import React, { useEffect, useState } from 'react';
import { List } from 'antd';
import { LarpTable } from '@tables';
import {sortByString} from '@utils'
import getHerbsForRecepy from '../functions/getHerbsForRecepy';
import { mapToFilter } from '../../../../utils/functions/filters';

export default function PotionRecepyWikiTable({
    potion
}) {
     const [dataSource, setDataSource] = useState([]);
     const [listSource, setListSource] = useState([]);
    //  const [isAddModalVisible, setIsAddModalVisible] = useState(false);

      useEffect(() => {
        refresh(potion.potionRecepies);
          }, // eslint-disable-next-line
      [potion])



      function refresh(newDataSource)
      {
        if(!Array.isArray(newDataSource)) {
          newDataSource = potion.potionRecepies
        }
        setDataSource([...newDataSource]);
        setListSource(tableList(newDataSource))
      }

      const columns = [
        {
          title: 'Id',
          dataIndex: 'id',
          key: 'id',
          hidden: true
        },
        {
            title: 'Herbs',
            key: 'herbs',            
            render: (record) => {
                return getHerbsForRecepy(record)
            },
            filters: herbfilterFromDatasource(dataSource),
            onFilter: (value, record) => {
              var found = false
              record.herbs.forEach(herb => {
                  if (herb.item.id === value) {
                    found = true
                  }
                }
              )
              return found}
        },
        {
            title: 'Discovered by',
            dataIndex: 'discoverdBy',
            key: 'discoverdBy',
            sorter: (a, b) => sortByString(a.discoverdBy, b.discoverdBy),
            sortDirections: ['ascend', 'descend', 'ascend'],
        }
    ].filter(_ => !_.hidden)

       function herbfilterFromDatasource(dataSource) {
          var filter = new Map()
          dataSource.forEach(record => 
            record.herbs.map( herb =>
              filter.set(
                herb.item?.id,
                herb.item?.name
              )
            )
          )
          return mapToFilter(filter)
        }

    return (
      <>
        <LarpTable 
          dataSource={dataSource}
          columns={columns}
          listSource={listSource}
        />
      </>
    )
}

export function tableList(  
    list,   
  ) {
    return list.map(_ => {
      return (
              <List.Item
                style={{display:"flex", flexDirection:"column"}}
              >
  
                <List.Item.Meta
                  style={{width:"100%"}}
                  title={_.amountCrafted > 1 ? `${_.amountCrafted} x ${_.potion?.item?.name}` : _.potion?.item?.name}
                  description={`Discovered by: ${_.discoverdBy}`}
                />
                <div className="list-tags">
                  {getHerbsForRecepy(_)}
                </div>
              </List.Item>
      )
    })
  }